import { isPlatformBrowser, NgIf } from "@angular/common";
import { AfterViewInit, ChangeDetectionStrategy, Component, Inject, Input, PLATFORM_ID } from "@angular/core";
import { SkeletonImageComponent } from "../../skeleton-image/skeleton-image/skeleton-image.component";

@Component({
  selector: "app-bloque-separador",
  templateUrl: "./bloque-separador.component.html",
  styleUrl: "./bloque-separador.component.scss",
  imports: [SkeletonImageComponent, NgIf],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BloqueSeparadorComponent implements AfterViewInit {
  @Input() contenido;
  @Input() lcp: boolean;

  constructor(@Inject(PLATFORM_ID) private platformId: object) {}

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      console.log("Bloque separador", this.contenido);
    }
    if (this.contenido) {
      console.log(this.contenido);
    }
  }
}
